import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ForgotPasswordForm = ({ onBack }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await axios.post("/auth/forgot-password", { email }); setSent(true); }
    catch { setError(t("auth.reset.requestFailed")); }
    finally { setLoading(false); }
  };

  if (sent) {
    return (
      <div className="space-y-5" data-testid="forgot-password-sent">
        <div className="flex items-start gap-3 p-4 bg-emerald-50 border border-emerald-200 rounded-sm text-sm text-emerald-900">
          <MailCheck className="w-5 h-5 shrink-0" /> <p>{t("auth.reset.sentMessage")}</p>
        </div>
        <Button variant="outline" data-testid="forgot-password-back" className="w-full h-11 rounded-sm" onClick={onBack}>
          <ArrowLeft className="w-4 h-4 mr-2" /> {t("auth.reset.backToLogin")}
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
      <p className="text-sm text-slate-500">{t("auth.reset.forgotIntro")}</p>
      <div className="space-y-2">
        <Label htmlFor="reset-email" className="text-xs font-semibold text-slate-600 uppercase tracking-wider">{t("auth.email")}</Label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input id="reset-email" data-testid="forgot-password-email" type="email" required placeholder="you@company.com" value={email}
            onChange={(e) => setEmail(e.target.value)} className="pl-10 h-12 bg-white border-slate-200" />
        </div>
      </div>
      {error && <p role="alert" data-testid="forgot-password-error" className="text-sm text-red-600">{error}</p>}
      <Button type="submit" data-testid="forgot-password-submit" disabled={loading}
        className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-xs uppercase tracking-widest rounded-sm">
        {loading ? t("auth.reset.sending") : t("auth.reset.sendLink")}
      </Button>
      <button type="button" data-testid="forgot-password-cancel" onClick={onBack} className="w-full text-xs text-slate-500 hover:text-indigo-600 transition-colors">
        {t("auth.reset.backToLogin")}
      </button>
    </form>
  );
};
